import { render, staticRenderFns } from "./ResetPasswordForm.vue?vue&type=template&id=d9f19ace"
import script from "./ResetPasswordForm.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordForm.vue?vue&type=script&lang=ts"
import style0 from "./ResetPasswordForm.vue?vue&type=style&index=0&id=d9f19ace&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports